import { render, staticRenderFns } from "./Councils.vue?vue&type=template&id=232e979a&scoped=true&"
import script from "./Councils.vue?vue&type=script&lang=ts&"
export * from "./Councils.vue?vue&type=script&lang=ts&"
import style0 from "./Councils.vue?vue&type=style&index=0&id=232e979a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e979a",
  null
  
)

export default component.exports